import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'app/shared/api/microservices';

const baseUrl = `${process.env.JOB_MANAGER_URL || 'http://localhost'}${process.env.JOB_MANAGER_PORT && process.env.JOB_MANAGER_PORT !== '' ? `:${process.env.JOB_MANAGER_PORT}` : ''}`;
const staggeredBaseQuery = axiosBaseQuery({ baseUrl: baseUrl });

export const jobManagerServiceApi = createApi({
  reducerPath: 'jobManagerApi',
  baseQuery: staggeredBaseQuery,
  endpoints: () => ({}),
});
